// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__14hP6","tab":"ProcedureTabs_tab__3dh40"};